import * as React from 'react'
import styled from 'styled-components'
import AppBar, {AppBarProps} from '@mui/material/AppBar'
import appbarStyles from './appbar.styles'

const AppbarAtom = styled((props: AppBarProps) => (
  <AppBar {...props} position="static" />
))`
  ${appbarStyles}
`

export default AppbarAtom
